module.exports = __webpack_public_path__ + "img/Body_Normal.a4c672e.png";